<template>
  <div :class="$style.wrap">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane
        v-for="branch in branchs"
        :key="branch.id"
        :label="branch.name"
        :name="branch.id"
      >
        <AllotModel1 :branch="branch" v-if="branch.id === activeName" />
      </el-tab-pane>
    </el-tabs>
    <el-button
      icon="el-icon-setting"
      :class="$style.set"
      @click="goQueueList"
      v-per="'AllotModel_Button_QueueList'"
      >队列设置</el-button
    >
  </div>
</template>

<script>
import AllotModel1 from "./allotModel";
import { getBranchList } from "@/modules/departments";
import { getBasicInfo } from "@/modules/user";
import { ROLE } from "@/modules/entities";
export default {
  name: 'AllotModel',
  inject: ["path"],
  components: {
    AllotModel1,
  },
  data() {
    return {
      activeName: getBranchList()[0].id,
    };
  },
  computed: {
    branchs() {
      if (
        [ROLE.BACK_DIRECTOR, ROLE.BACK_MANAGER, ROLE.INSPECTOR].includes(getBasicInfo().role)
      ) {
        return getBranchList().filter((item) => {
          return item.id === getBasicInfo().dep.branch_id;
        });
      } else {
        return getBranchList();
      }
    },
  },
  mounted() {
    if (this.branchs.length) {
      this.activeName = this.branchs[0].id
    }
  },
  methods: {
    goQueueList() {
      this.$router.push({name:'QueueList'});
    },
  },
};
</script>

<style lang="scss" module>
.wrap {
  background: #fff;
}
.set {
  position: absolute;
  top: 0;
  right: 0;
}
</style>